<template>
  <div id="page-container">
    <nav-bar></nav-bar>
    <accept-terms></accept-terms>
    <router-view></router-view>
    <footer-brand></footer-brand>
  </div>
</template>
<script>
import Navbar from '@/components/Navbar'
import AcceptTerms from '@/components/AcceptTermsConditions'
import FooterBrand from '@/components/FooterBrand'
export default {
  name: 'PublicLayout',
  components: {
    'nav-bar': Navbar,
    'accept-terms': AcceptTerms,
    'footer-brand': FooterBrand
  },
  created: function () {
    /* remove classes added with admin theme */
    document.body.classList.remove('app', 'header-fixed', 'sidebar-fixed', 'aside-menu-fixed', 'aside-menu-hidden')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/public/PublicLayout.vue